import React, { useState } from 'react';

// StarRating Component
const StarRating = ({ rating, onRatingChange }) => {
  const stars = [1, 2, 3, 4, 5]; // Array representing 5 stars

  return (
    <div className="star-rating">
      {stars.map((star) => (
        <span
          key={star}
          className={`star ${star <= rating ? 'filled' : ''}`}
          onClick={() => onRatingChange(star)}
          style={{
            cursor: 'pointer',
            color: star <= rating ? '#FFD700' : '#C0C0C0', // Gold for filled stars, Silver for empty stars
            fontSize: '24px', // Adjust star size as needed
          }}
        >
          ★
        </span>
      ))}
    </div>
  );
};

export default StarRating;
